import React from 'react';
import  "../components/Header";
import  './Hero.css'
import  '../components/Buttons.css'
import  '../components/PrimButtons.css'
import  '../assets/hero.webp'
import Guide from "./Guide";
import {HashLink} from "react-router-hash-link";
import illust from '../assets/hero_img.webp'
import Metrics from "../components/Metrics";
import Assumptions from "../components/Assumptions";
import {Helmet} from "react-helmet";

const Hero = () => {
    return (
        <div>
            <Helmet>
                <title>Zyrka – Automotive Lot Management</title>
                <meta name="description" content="Zyrka helps car dealers locate and manage inventory faster, saving time and increasing sales." />
            </Helmet>
            <div className={'Hero'}>
                <div className={'wrapper'}>
                    <div className="Text">
                        <h1>
                            zyrka
                        </h1>
                        <p>
                        <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
                            Unblock Your Lot. Find Cars Fast.
                         </span><br />
                            <span>
                            Zyrka helps you track every vehicle on your lot— <br />
                        so your team stops wasting time and starts closing more deals.
                            </span>
                        </p>
                        <div className={'button-wrapper'}>
                            <HashLink smooth to={'/#guide1'}>
                                <button className={'prim-button'} color={'white'}>
                                    Get Started
                                </button>
                            </HashLink>
                            <HashLink smooth to={'/#guide'}>
                                <button className={'button-13'}>
                                    How It Works
                                </button>
                            </HashLink>
                        </div>
                    </div>
                    <img src={illust} alt="" className={'heroPic'}/>
                </div>
                <Metrics/>
                <Guide/>
                <div id={'guide1'}>
                </div>
                <Assumptions/>
            </div>
        </div>
    );
};

export default Hero;